import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["keyname", "name", "rename", "panel", "label"];
import { useEffect, memo } from 'react';
import { Input, useStore } from 'react-login-page';
import { jsx as _jsx } from "react/jsx-runtime";
export var Password = /*#__PURE__*/memo(props => {
  var {
      keyname = 'password',
      name,
      rename,
      panel = 'login',
      label = 'Password'
    } = props,
    elmProps = _objectWithoutPropertiesLoose(props, _excluded);
  var {
    dispatch
  } = useStore();
  var panelName = panel;
  var key = keyname || name;
  useEffect(() => dispatch({
    ["$$" + panelName + key]: label
  }), [label]);
  var nameBase = name || rename || keyname;
  return /*#__PURE__*/_jsx(Input, _extends({
    type: "password",
    placeholder: "Password",
    autoComplete: "on",
    index: 2
  }, elmProps, {
    name: nameBase,
    keyname: "$$" + panelName + key
  }));
});
Password.displayName = 'Login.Password';